import React from "react";
import { BannerView } from "./BannerView";
import {
  loadContent,
  getNotification,
  updateSessionStorage,
  getAccountId
} from "./helpers";

interface IState {
  show: boolean;
  showMyAccountButton: boolean;
  msg: string;
}
type MessageTypes = "msgError" | "msgNB" | "msgA" | "msgB";

class SecurityBreachBanner extends React.Component<any, IState> {
  state = {
    show: false,
    showMyAccountButton: false,
    msg: ""
  };

  interval!: number;

  onCloseButtonClick = () => {
    updateSessionStorage("securitybanner", { status: "close" });
    this.setState({ show: false });
  };

  onSearchMyAccBtnClick = async () => {
    let msg = "";
    let messageType: MessageTypes = "msgNB";
    const sessionContentStr = sessionStorage.getItem("securitybanner");
    const sbBanner = sessionContentStr ? JSON.parse(sessionContentStr) : {};
    const { msgA, msgB, msgNB, msgError } = sbBanner.content;

    try {
      const { data } = await getNotification();

      if (!data) {
        // Response was not an HTTP 200 or the response didn't return the expected data
        messageType = "msgError";
        msg = msgError;
      } else if (!data.securityBreach) {
        // account number hasn't been breached
        messageType = "msgNB";
        msg = msgNB;
      } else {
        // account number has been breached
        if (data.type === "A") {
          messageType = "msgA";
          msg = msgA;
        } else if (data.type === "B") {
          messageType = "msgB";
          msg = msgB;
        } else {
          messageType = "msgError";
          msg = msgError;
        }
      }
    } catch (e) {
      messageType = "msgError";
      msg = msgError;
    } finally {
      updateSessionStorage("securitybanner", {
        messageType,
        id: getAccountId()
      });
      this.setState({
        show: true,
        msg,
        showMyAccountButton: false
      });
    }
  };

  clearIntervalAndUpdateState = (id, messageType, content) => {
    const accountId = getAccountId();
    if (!accountId) {
      return;
    }
    clearInterval(this.interval);
    const isSameUser = accountId === id;
    const msg = isSameUser ? content[messageType] : content.msgDefault;
    return this.setState({
      show: true,
      showMyAccountButton: !isSameUser,
      msg
    });
  };

  displayBanner = async () => {
    const intervalToCheckCH = 300;
    const { id, status, messageType, content } = await loadContent(
      "securitybanner"
    );
    if (status !== "open" || (content && !content.enabled)) {
      return;
    }
    if (!id) {
      return this.setState({
        show: true,
        showMyAccountButton: true,
        msg: content.msgDefault
      });
    } else {
      // It takes few seconds to bootstrap the my-account context-hub with the responses
      // of the api calls made on the my-account dashboard page. Hence the setInterval method call.
      if (!getAccountId()) {
        this.interval = window.setInterval(
          () => this.clearIntervalAndUpdateState(id, messageType, content),
          intervalToCheckCH
        );
      } else {
        // user has already logged in.
        return this.clearIntervalAndUpdateState(id, messageType, content);
      }
    }
  };

  componentDidMount() {
    return this.displayBanner();
  }

  componentWillUnmount() {
    window.clearInterval(this.interval);
  }

  render() {
    const { show, showMyAccountButton, msg } = { ...this.state } as IState;
    return show ? (
      <BannerView
        message={msg}
        searchMyAccBtnVisible={showMyAccountButton}
        onCloseButtonClick={this.onCloseButtonClick}
        onSearchMyAccBtnClick={this.onSearchMyAccBtnClick}
        closeBtnDataId={"sbCloseBtn"}
        myAccBtnDataId={"sbMyAccBtn"}
      />
    ) : null;
  }
}

export default SecurityBreachBanner;
